import React from 'react';
// Modules
import {
  Box,
  Button,
  Container,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
  Text,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { NextPage } from 'next/types';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
// Components
import Page from '../components/layout/Page';
// Firebase
import firebase from '../firebase/client';
// Utils
import { parseError } from '../utils/helpers';

interface FormData {
  email: string;
}

const validationSchema = yup.object().shape({
  email: yup.string().email('Email tidak valid.').required('Tidak boleh kosong.'),
});

const ForgotPasswordPage: NextPage = () => {
  const toast = useToast();

  const {
    control, errors, formState, handleSubmit, reset,
  } = useForm<FormData>({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      await firebase.auth().sendPasswordResetEmail(data.email);

      reset();

      toast({
        description: `Kode verifikasi telah dikirim ke ${data.email}.`,
        status: 'success',
      });
    } catch (e) {
      toast({
        description: parseError(e),
        status: 'error',
      });
    }
  });

  return (
    <Page>
      <Container minH="75vh" py="16">
        <form onSubmit={onSubmit}>
          <VStack alignItems="stretch" spacing="8">
            <VStack alignItems="flex-start">
              <Heading as="h1" size="lg">
                Lupa Kata Sandi
              </Heading>
              <Box bgColor="primary.500" h="4px" w="64px" />
            </VStack>

            <Text>
              Masukkan alamat email yang terdaftar. Kami akan mengirimkan kode verifikasi untuk atur
              ulang kata sandi.
            </Text>

            <Controller
              control={control}
              name="email"
              render={({ onBlur, onChange, value }) => (
                <FormControl id="email" isInvalid={!!errors.email}>
                  <FormLabel>Alamat Email</FormLabel>
                  <Input
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.value.trim())}
                    type="email"
                    value={value}
                  />
                  {errors.email && (
                    <FormHelperText color="red.500">{errors.email.message}</FormHelperText>
                  )}
                </FormControl>
              )}
            />

            <Button
              alignSelf="flex-start"
              colorScheme="primary"
              isLoading={formState.isSubmitting}
              textColor="black"
              type="submit"
            >
              Kirim
            </Button>
          </VStack>
        </form>
      </Container>
    </Page>
  );
};

export default ForgotPasswordPage;
